module.exports = __webpack_public_path__ + "static/media/page-loader.c3349add.gif";